export class Utilities {
    static injectMatomoScript(containerId: string): void {
        if (typeof window === 'undefined') return;

        if ((window as any)._mtmScriptInjected) return;
        (window as any)._mtmScriptInjected = true;

        const _mtm = (window as any)._mtm = (window as any)._mtm || [];
        _mtm.push({ 'mtm.startTime': new Date().getTime(), event: 'mtm.Start' });

        const script = document.createElement('script');
        script.async = true;

        script.src = `https://cdn.matomo.cloud/cabi.matomo.cloud/${containerId}.js`;

        const firstScript = document.getElementsByTagName('script')[0];
        firstScript?.parentNode?.insertBefore(script, firstScript);
    }
}
